<template>
  <v-container>
    <Loader :isLoading="true"/>
    <div class="text-center">{{ status }}</div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {
    //
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  data: () => ({
    status: null,
  }),
  async created() {
    const { code, uid } = this.$route.query;

    this.status = "Resetting...";
    
    await Promise.all([
      this.$store.dispatch("resetCoin"),
      this.$store.dispatch("resetPick"),
      this.$store.dispatch("resetSkin"),
      this.$store.dispatch("resetApparel"),
      this.$store.dispatch("resetTutorial"),
      this.$store.dispatch("resetBoss"),
      this.$store.dispatch("resetEvent"),
      this.$store.dispatch("resetSeries"),
      this.$store.dispatch("resetGameCache"),
      this.$store.dispatch("resetMiniGame"),
      this.$store.dispatch("resetABC"),
      this.$store.dispatch("resetMath"),
    ]);

    if(this.auth.code) {
      this.status = "Exiting old session...";
      await this.$store.dispatch("logout");
    }

    this.status = "Setting new session...";

    // Set SSO flag in sessionStorage
    sessionStorage.setItem('ssoFlow', 'true');

    this.status = "Redirecting...";

    const query = {};
    if (code) query.code = code;
    if (uid) query.uid = uid;

    this.$router.replace({
      name: "PageAccessMain",
      query,
    });
  },
  methods: {
    //
  },
};
</script>

<style scoped>
</style>